import React from 'react';
import { RootContainer } from './RootContainer.jsx';

/**
 * Canvas
 *
 * The editing surface. Renders the RootContainer which in turn renders all
 * blocks recursively.
 *
 * Props:
 *   style {object} – optional additional styles
 */
export function Canvas({ style }) {
  return (
    <div
      className="editor-canvas"
      style={{
        flex: 1,
        overflowY: 'auto',
        padding: '16px 20px',
        background: '#fff',
        ...style,
      }}
    >
      <RootContainer />
    </div>
  );
}
